import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InfoCircleFilled, ArrowLeftOutlined, ShoppingCartOutlined, TeamOutlined } from "@ant-design/icons";
import { Button, Row, Col } from "antd";
import PagesHeader from "../../../components/PageHeader";
import ButtonBar from "../../../components/ButtonNavigation/index";

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(6);

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/all-installers");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="inspectionWrapper">
      <div className="inspectionHeader">
        <PagesHeader title="Checkout Cancelled" />
      </div>

      <div className="buttonSection">
        <div className="container-xxl" style={{ paddingLeft: "32px", paddingRight: "32px" }}>
          <Row>
            <Col xs={24} md={24} className="text-end">
              <ButtonBar />
            </Col>
          </Row>
        </div>
      </div>

      <div className="inspectionWrapInner" style={{ padding: "40px 0 60px" }}>
        <div className="container-xxl" style={{ paddingLeft: "32px", paddingRight: "32px" }}>
          <div
            style={{
              maxWidth: "580px",
              margin: "0 auto",
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              padding: "42px 32px",
              textAlign: "center",
              boxShadow: "0 4px 24px rgba(15, 23, 42, 0.06)",
            }}
          >
            {/* Notice Icon */}
            <div
              style={{
                width: "72px",
                height: "72px",
                borderRadius: "50%",
                background: "#fff7ed",
                color: "#ea580c",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "40px",
                margin: "0 auto 20px auto",
                boxShadow: "0 4px 16px rgba(234, 88, 12, 0.2)",
              }}
            >
              <InfoCircleFilled />
            </div>

            <h2
              style={{
                fontSize: "24px",
                fontWeight: 600,
                color: "#0f172a",
                margin: "0 0 8px 0",
                letterSpacing: "-0.3px",
              }}
            >
              Checkout Not Completed
            </h2>

            <p
              style={{
                fontSize: "14.5px",
                color: "#64748b",
                lineHeight: 1.6,
                margin: "0 0 28px 0",
              }}
            >
              You left the Stripe checkout session. No charge has been made to your payment method, and your current subscription plan remains unchanged.
            </p>

            <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
              <Button
                type="default"
                icon={<TeamOutlined />}
                onClick={() => navigate("/all-installers")}
                style={{
                  height: "44px",
                  padding: "0 22px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "14px",
                  color: "#475569",
                  borderColor: "#cbd5e1",
                  background: "#ffffff",
                }}
              >
                Back to Installers ({countdown}s)
              </Button>

              <Button
                type="primary"
                icon={<ShoppingCartOutlined />}
                onClick={() => navigate("/installer/subscription")}
                style={{
                  height: "44px",
                  padding: "0 24px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "14px",
                  background: "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
                  borderColor: "transparent",
                  boxShadow: "0 3px 12px rgba(2, 132, 199, 0.35)",
                }}
              >
                Try Checkout Again
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
